import React from 'react';
import withIconProps from './utils/withIconProps';

const SvgWebhook = ({ title, ...props }) => (
  <svg
    id="webhook_svg__Layer_1"
    x={0}
    y={0}
    viewBox="0 0 16 16"
    xmlSpace="preserve"
    aria-labelledby="title"
    role="img"
    {...props}
  >
    {title ? <title>{title}</title> : null}
    <style>{'.webhook_svg__st0{fill:#fff}'}</style>
    <path d="M10.4 12H8c-.2 1.2-.8 2.1-1.7 2.7-.8.5-1.7.8-2.7.6-2.1-.2-3.5-2-3.5-3.9 0-2.1 1.5-3.7 3.3-4 .1.4.1.7.2 1.1h-.2c-1.1.3-1.9 1-2.1 2.2-.3 1.5.6 3 2.1 3.4 1.1.3 2.1-.1 2.8-.9.4-.4.6-.9.7-1.4V11v-.2h3.5s.1 0 .1-.1c.2-.5.6-.9 1.2-1 .6-.1 1.1 0 1.5.4.4.4.6.9.6 1.5-.1.5-.3 1-.8 1.3-.5.3-1 .4-1.6.1-.5-.2-.8-.5-1-1zm2.2-.6c0-.3-.3-.6-.6-.6s-.6.3-.6.6.3.6.6.6.6-.3.6-.6z" />
    <path d="M9 14.1c.3-.3.6-.5.8-.8l.3.3c.5.4 1 .6 1.7.7 1.4.1 2.6-.8 3-2.1.4-1.5-.5-3.1-2.1-3.5-.7-.2-1.4-.1-2.1.3l-.6.3v-.1c-.5-1-1.1-1.9-1.7-2.9 0 0 0-.1-.1 0-.5 0-.9-.1-1.3-.4-.3-.3-.5-.6-.6-1.1-.1-.5 0-.9.3-1.3s.6-.6 1.1-.6c.4-.1.8 0 1.2.3.4.2.6.6.7 1 .1.6 0 1.1-.4 1.5.4.7.8 1.3 1.2 2 1.2-.4 2.3-.4 3.4.2.8.4 1.4 1.1 1.8 2 .8 1.8.1 3.9-1.6 5-1.6 1-3.7.6-5-.8zm-.4-9.5c0-.3-.3-.6-.6-.6s-.6.3-.6.6.3.6.6.6c.3-.1.6-.3.6-.6z" />
    <path d="M11.8 5.9c-.4-.1-.7-.2-1.1-.4 0-.1 0-.1.1-.2.4-1.5-.5-3.2-2-3.5-1.6-.4-3.2.5-3.6 2.1-.3 1.1.2 2.3 1.2 3 .1.1.3.2.4.4 0 .1-.1.2-.1.2-.5.9-1 1.8-1.4 2.7v.1c.3.4.5.9.4 1.4-.1.6-.4 1-.9 1.3-.5.3-1 .3-1.5.1-.5-.2-.8-.6-.9-1-.2-.5-.1-1.1.2-1.5.3-.4.6-.6 1.1-.7h.6c.3-.9.7-1.6 1.1-2.3A4.1 4.1 0 014 4.5c0-1 .4-1.9 1-2.6C6.3.4 8.4.2 10.1 1.2c1.7 1 2.3 3.1 1.7 4.7zm-7.2 5.5c0-.3-.3-.6-.6-.6s-.6.3-.6.6.3.6.6.6.6-.3.6-.6z" />
    <path
      className="webhook_svg__st0"
      d="M12.6 11.4c0 .3-.3.6-.6.6s-.6-.3-.6-.6.3-.6.6-.6c.3.1.6.3.6.6zM8.6 4.6c0 .3-.3.6-.6.6s-.6-.3-.6-.6.3-.6.6-.6.6.3.6.6zM4.6 11.4c0 .3-.3.6-.6.6s-.6-.3-.6-.6.3-.6.6-.6c.3.1.6.3.6.6z"
    />
  </svg>
);

SvgWebhook.displayName = 'Webhook';
export default withIconProps(SvgWebhook);
